module.exports = __webpack_public_path__ + "static/Logo.c814cd70.svg";